<div [formGroup]="form" class="flex flex-column gap-2">
  <label [attr.for]="item.key" class="font-semibold"
    >{{ item.label || '' | translate }}
    <span class="asterisk" *ngIf="item.required">*</span>
  </label>

  <p-dropdown
    styleClass="w-full"
    ngClass="{{ isInValid ? 'ng-invalid ng-dirty' : '' }}"
    [placeholder]="item.placeholder || placeholder | translate"
    [options]="item.options"
    optionLabel="label"
    optionValue="value"
    [formControlName]="item.key"
    [filter]="item.config?.searchable"
  >
    <ng-template pTemplate="selectedItem">
      {{ getLabelByValue(value) | translate }}
    </ng-template>

    <ng-template let-option pTemplate="item">
      <div>{{ option.label | translate }}</div>
    </ng-template>
  </p-dropdown>

  <small
    class="p-error block font-italic"
    *ngIf="isInValid && hasError('required')"
  >
    {{
      item.errorMessage?.required?.message || ''
        | translate : item.errorMessage?.required?.params
    }}
  </small>
</div>
